import PageContent from './navigation/page-content/page-content';
import { Provider } from './context';
import './App.scss';
import { useEffect } from 'react';
import useFetch from './customHooks/useFetch';
import useStore from './customHooks/useStore';
import { QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider, Text } from '@mantine/core';
import { getStoredRole, isAdminRole } from './utils/authRole';
import { queryClient } from './queryClient';

//initialize app

function App() {
  // this is the top level of the application.

  const setLanguage = useStore((state) => state.setLanguage);

  const [res, callGetAPI] = useFetch({
    url: `lang`,
    method: 'GET',
    responseFormat: 'TEXT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });

  useEffect(() => {
    callGetAPI();
  }, []);

  useEffect(() => {
    if (isAdminRole(getStoredRole())) {
      setLanguage('en');
      return;
    }

    if (res.data) {
      setLanguage(res.data);
    } else {
      setLanguage(window.Localize.getLanguage() || 'en');
    }
  }, [res]);

  return (
    <div id='App'>
      <QueryClientProvider client={queryClient}>
        <MantineProvider withGlobalStyles withNormalizeCSS>
          <Provider>
            {/* provider will give the app reusable functions and a global state
          - context.js will hold these functions and state variables 
          - pagecontent is going to have the initial routing for the application 
          */}
            <PageContent />
          </Provider>
        </MantineProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;
